var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Survey, SurveyElementBase, ReactElementFactory } from "survey-react-ui";
import { SearchComponent } from "../components/Search";
var PropertyGridComponent = /** @class */ (function (_super) {
    __extends(PropertyGridComponent, _super);
    function PropertyGridComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PropertyGridComponent.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    PropertyGridComponent.prototype.getStateElement = function () {
        return this.model;
    };
    PropertyGridComponent.prototype.canRender = function () {
        if (!this.model)
            return false;
        return _super.prototype.canRender.call(this);
    };
    PropertyGridComponent.prototype.renderElement = function () {
        return (React.createElement("div", { className: this.model.rootCss },
            React.createElement(SearchComponent, { model: this.model.searchManager }),
            React.createElement(Survey, { model: this.model.survey })));
    };
    return PropertyGridComponent;
}(SurveyElementBase));
export { PropertyGridComponent };
export default PropertyGridComponent;
ReactElementFactory.Instance.registerElement("svc-property-grid", function (props) {
    return React.createElement(PropertyGridComponent, props);
});
